(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('widgetAcumuladoChuva', WidgetAcumuladoChuva);

  function WidgetAcumuladoChuva() {
    return {
      templateUrl: 'views/widgets/acumulado-chuva/view.html',
      restrict: 'A',
      controller: 'WidgetAcumuladoChuvaCtrl',
      controllerAs: 'wctrl',
      scope: {
        widget: '=data'
      }
    };
  }
}());
